import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';
import { SettlementChangeRequest } from './types';
import { toast } from '@ravenpay/raven-bank-ui';
import { getCookie } from '../utils/helper/Helper';
import { decrypt2 } from '../utils/encrypt';
import axios from '../utils/banbox_axios';
import { bankboxSlice } from './bankbox';

export const fetchSettlementRequest = createAsyncThunk<
	SettlementChangeRequest,
	string,
	{ rejectValue: any }
>(
	'/atlas/pdon/settlement/single_account_request',
	async (email: string, thunkAPI) => {
		try {
			const { data } = await axios.get(
				`/atlas/pdon/settlement/single_account_request`,
				{
					params: { email },
					headers: {
						'Content-Type': 'application/json',
						Authorization: `Bearer ${getCookie('token') || ''}`,
						'x-pos-key': getCookie('x-pos-key') || '',
					},
				}
			);

			if (data?.status === 'fail') {
				if (typeof data?.data === 'string') {
					// toast.error(data?.data);
				} else {
					// toast.error(data?.message, {
					// 	position: 'top-right',
					// });
				}

				return thunkAPI.rejectWithValue(data);
			}

			if (data?.status === 'success') {
				data?.data?.data;
				thunkAPI.dispatch(setSettlementreq(data?.data?.data));
				return data;
			}
		} catch (error: any) {
			if (error.message === 'Network Error') {
				toast.error(error.message, {
					position: 'top-right',
				});
			}
			if (
				error.response.data.status === 'fail' &&
				error.response.status !== 401
			) {
				return thunkAPI.rejectWithValue(error);
			}
		}
	}
);

export const respondToSettlementRequest = createAsyncThunk<
	any,
	{
		id: number;
		email: string;
		status: 'approved' | 'rejected';
		note?: string;
	},
	{ rejectValue: any }
>('settlement/respond', async (payload, thunkAPI) => {
	try {
		const res = await axios.post(
			`/atlas/pdon/settlement/account_change_request`,
			{
				id: payload.id,
				status: payload.status,
				email: payload.email,
				note: payload.note || '',
			},
			{
				headers: {
					'Content-Type': 'application/json',
					Authorization: `Bearer ${getCookie('token') || ''}`,
					'x-pos-key': getCookie('x-pos-key') || '',
				},
			}
		);

		const data = res.data;

		if (data?.status === 'fail') {
			if (typeof data?.data === 'string') {
				toast.error(data?.data);
			} else {
				toast.error(data?.message, {
					position: 'top-right',
				});
			}

			return thunkAPI.rejectWithValue(data);
		}

		if (data?.status === 'success') {
			toast.success(data?.data?.message, {
				position: 'top-right',
			});
			// thunkAPI.dispatch(setSettlementres(data?.data?.data));
			return data;
		}
	} catch (error: any) {
		if (error.message === 'Network Error') {
			toast.error(error.message, {
				position: 'top-right',
			});
		}
		if (
			error.response.data.status === 'fail' &&
			error.response.status !== 401
		) {
			return thunkAPI.rejectWithValue(error);
		}
	}
});

export interface SettlementState {
	request: SettlementChangeRequest | null;
	showActionBar: boolean;
	errorMessage: string | null;
	loading: boolean;
	settlement_request: any;
}

const initialState: SettlementState = {
	request: null,
	showActionBar: false,
	errorMessage: null,
	loading: false,
	settlement_request: {},
};

const settlementSlice = createSlice({
	name: 'settlement',
	initialState,
	reducers: {
		setSettlementreq: (state, action) => {
			state.settlement_request = action.payload;
		},
		setSettlementres: (state, action) => {
			state.loading = action.payload;
		},
	},
	extraReducers: (builder) => {
		builder.addCase(fetchSettlementRequest.pending, (state) => {
			state.loading = true;
		});

		builder.addCase(fetchSettlementRequest.fulfilled, (state, action) => {
			state.showActionBar = true;
			state.loading = false;
		});

		builder.addCase(fetchSettlementRequest.rejected, (state, action) => {
			state.errorMessage = action.payload as string;
			state.showActionBar = false;
			state.loading = false;
		});

		builder.addCase(respondToSettlementRequest.pending, (state) => {
			state.loading = true;
		});

		builder.addCase(respondToSettlementRequest.fulfilled, (state, action) => {
			state.showActionBar = false;
			state.loading = false;

			if (action.meta.arg.status === 'approved') {
				state.request = {
					...action.payload.data,
					date_requested: new Date().toISOString(),
				};
			} else {
				state.request = null;
			}

			state.request = null;
		});

		builder.addCase(respondToSettlementRequest.rejected, (state, action) => {
			state.errorMessage = action.payload as string;
			state.showActionBar = true;
			state.loading = false;
		});
	},
});

export const { setSettlementreq, setSettlementres } = settlementSlice.actions;
export default settlementSlice.reducer;
